import React, { useState, useEffect, useRef } from 'react'
import { useDataEngine } from '@dhis2/app-runtime';
import { useAuth } from '../auth/AuthContext';
import MyObjectivesList from './MyObjectives';

// Simple context provider for MyObjectives without the add button
const MyObjectivesContext = React.createContext();

const MyObjectivesWrapper = ({ children, reportMode = false }) => {
    const engine = useDataEngine();
    const { user } = useAuth();
    const [events, setEvents] = useState([]);
    const [loadingEvents, setLoadingEvents] = useState(true);
    const [dataLoaded, setDataLoaded] = useState(false);

    useEffect(() => {
        const fetchEvents = async () => {
            if (!user?.organisationUnits?.length) {
                setLoadingEvents(false);
                return;
            }

            try {
                console.log('📊 [MyObjectivesWrapper] Fetching events...');
                const response = await engine.query({
                    events: {
                        resource: 'events',
                        params: {
                            program: 'yiT00XKrrHP',
                            orgUnit: user.organisationUnits[0].id,
                            fields: 'event,orgUnit,storedBy,createdByUserInfo[username],lastUpdatedByUserInfo[username],trackedEntityInstance,enrollment,programStage,dataValues[dataElement,value]',
                            pageSize: 500
                        }
                    }
                });
                const fetchedEvents = response.events?.events || [];
                console.log(`✅ [MyObjectivesWrapper] Loaded ${fetchedEvents.length} events`);
                setEvents(fetchedEvents);
                setDataLoaded(true);
            } catch (error) {
                console.error('❌ Failed to fetch events:', error);
                setEvents([]);
            } finally {
                setLoadingEvents(false);
            }
        };

        fetchEvents();
    }, [user, engine]);

    const contextValue = {
        events,
        loadingEvents,
        dataLoaded,
        onEdit: () => {},
        onDelete: () => {},
        setLoading: () => {},
        setData: () => {},
        editingLevelId: null
    };

    return (
        <MyObjectivesContext.Provider value={contextValue}>
            <div 
                id="my-objectives-content"
                data-report-content="true"
                className="my-objectives-content"
                style={{
                    display: 'block',
                    width: '100%',
                    maxWidth: '100%',
                    overflow: 'visible'
                }}
            >
                {children}
            </div>
        </MyObjectivesContext.Provider>
    );
};

export const useMyObjectivesContext = () => {
    const context = React.useContext(MyObjectivesContext);
    if (!context) {
        throw new Error('useMyObjectivesContext must be used within a MyObjectivesWrapper');
    }
    return context;
};

const MyObjectivesPage = ({ reportMode = false, id = 'my-objectives-content' }) => {
    return (
        <MyObjectivesWrapper reportMode={reportMode}>
            <MyObjectivesList 
                reportMode={reportMode} 
                containerId={id}
            />
        </MyObjectivesWrapper>
    )
}

export default MyObjectivesPage;